import * as Styled from './styled';

function Subtitle({ children, ...props }) {
  return <Styled.Subtitle {...props}>{children}</Styled.Subtitle>;
}

export default Subtitle;
